import request from "@/utils/request";


export function getWorksList(data) {
  return request.get("/schoolWorks/list", data, { login: true });
}


export function schoolEditWorks(params) {
  return request.post(`/schoolWorks/edit`,params, { login: true });
}